import React, { useEffect, useState } from "react";
import {
  Container,
  Form,
  Nav,
  Navbar,
  NavDropdown,
  Accordion,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useLocation } from "react-router-dom";
import config from "../../config/index";
import toast, { Toaster } from "react-hot-toast";

//
import { useWeb3Modal } from "@web3modal/wagmi/react";
import { useAccount } from "wagmi";

import { Button, NavLink } from "react-bootstrap";

export default function Header2() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  //
  const { isConnected, address, chainId, isDisconnected, chain } = useAccount();
  const { isOpen, open, close } = useWeb3Modal();

  const show = (e) => {
    e.preventDefault();
    try {
      open();
    } catch (error) {
      console.log("Err", error);
    }
  };

  const goToHome = (e) => {
    e.preventDefault();
    navigate(`${config.baseUrl}`);
    document.body.classList.remove('dark-mode');
    document.body.classList.remove('light-mode');
    window.scrollTo(0, 0);
  };

  return (
    <>
      <Toaster />
      <section className="header">
        <>
          <Navbar expand="xl" className="bg-body-tertiary py-0">
            <Container>
              <Navbar.Brand href="#">
                <div className="logo d-block d-md-flex">
                  <div>
                    {location.pathname === `${config.baseUrl}` ? (
                      <img
                        src={`${config.baseUrl}images/logos/logoMultichain.png`}
                        alt="home"
                        onClick={(e) => goToHome(e)}
                        width={180}
                      />
                    ) : location.pathname === `${config.baseUrl}about` ||
                      location.pathname === `${config.baseUrl}contact` ? (
                      <img
                        src={`${config.baseUrl}images/logos/logoMultichain.png`}
                        alt=""
                        onClick={(e) => goToHome(e)}
                        width={180}
                      />
                    ) : (
                      <img
                        src={`${config.baseUrl}images/logos/logoMultichain.png`}
                        alt="trade"
                        onClick={(e) => goToHome(e)}
                        width={180}
                      />
                    )}
                  </div>
                </div>
              </Navbar.Brand>
              <Navbar.Toggle aria-controls="navbarScroll" />
              <Navbar.Collapse id="navbarScroll">
                <Nav
                  className=" my-2 my-lg-0 justify-content-end w-100 me-4"
                  navbarScroll
                >
                  {/* <Nav.Link className="me-xxl-3 " href={`${config.baseUrl}Docs/How it works.pdf`} target="_blank" rel="noopener noreferrer">How It Works</Nav.Link>
                                    <Nav.Link className="me-xxl-3 " href={`${config.baseUrl}about`} target="_blank" rel="noopener noreferrer">About Us</Nav.Link>
                                    <Nav.Link className="me-xxl-3 " href={`${config.baseUrl}faq`} target="_blank" rel="noopener noreferrer">FAQ</Nav.Link>
                                    <Nav.Link className="me-xxl-3 " href={`${config.baseUrl}contact`}target="_blank" rel="noopener noreferrer">Contact Us</Nav.Link>
                                    <NavLink className="me-xxl-3 " href={`${config.baseUrl}Docs/The WhitePaper.pdf`} target="_blank" rel="noopener noreferrer">Whitepaper</NavLink>
                                    <NavLink className="me-xxl-3 " href={`${config.baseUrl}Docs/Platform Insights.pdf`} target="_blank" rel="noopener noreferrer">Platform Insights</NavLink>
                                    <Nav.Link className="me-xxl-3 " href="https://infimultichain.com/ico" target="_blank" rel="noopener noreferrer">INFI ICO</Nav.Link>
                                    <Nav.Link className="me-xxl-3 " href="https://infimultichain.com/" target="_blank" rel="noopener noreferrer">INFI CDEX</Nav.Link>
                                    <NavLink className="" href={`${config.baseUrl}Docs/Staking & Rewards Explained.pdf`} target="_blank" rel="noopener noreferrer">Staking & Rewards</NavLink> */}
                  <NavDropdown
                    title="Quick Links"
                    id="basic-nav-dropdown"
                    className="headerDropdown"
                  >
                    {/* <div className="d-head mb-2">INFI Hub</div> */}
                    <div className="p-3">
                      <Accordion defaultActiveKey="0" alwaysOpen>
                        <NavDropdown.Item
                          href={`${config.baseUrl}`}
                          className="mb-2 active"
                        >
                          <div className="d-flex align-items-center">
                            <div>
                              <img
                                src="images/dashboard/icon/home.svg"
                                className=""
                                alt=""
                              />
                            </div>
                            <div>INFI HUB</div>
                          </div>
                        </NavDropdown.Item>

                        <Accordion.Item eventKey="1" className="mb-2">
                          <Accordion.Header>
                            {" "}
                            <img
                              src="images/dashboard/icon/swap.svg"
                              className=""
                              alt=""
                            />
                            INFI Main
                          </Accordion.Header>
                          <Accordion.Body className="p-0">
                            <NavDropdown.Item href="https://infimultichain.com/app/simplestaking" target="_blank" rel="noreferrer noopener">
                              Staking
                            </NavDropdown.Item>
                            <NavDropdown.Item href="https://infimultichain.com/app/dashboard" target="_blank" rel="noreferrer noopener">
                              SbSe Pools
                            </NavDropdown.Item>
                            <NavDropdown.Item href="#action/3.3">
                              Profits
                            </NavDropdown.Item>
                          </Accordion.Body>
                        </Accordion.Item>
                        {/* <NavDropdown.Item
                          href={"https://infimultichain.com/ico/"}
                          target="_blank"
                          rel="noreferrer noopener"
                          className="mb-2"
                        >
                          <img
                            src="images/dashboard/icon/ico.svg"
                            className=""
                            width={`22px`}
                            alt=""
                          />{" "}
                          INFI ICO
                        </NavDropdown.Item> */}
                        <Accordion.Item eventKey="2" className="mb-2">
                          <Accordion.Header>
                            {" "}
                            <img
                              src="images/dashboard/icon/launchpad.svg"
                              className=""
                              alt=""
                            />
                            INFI Launchpad
                          </Accordion.Header>
                          <Accordion.Body className="p-0">
                            <NavDropdown.Item href={`${config.baseUrl}launchpad`}>
                              Launchpad Home
                            </NavDropdown.Item>
                            <NavDropdown.Item href={`${config.baseUrl}launchpad#activepresale`}>
                              Active ICO's
                            </NavDropdown.Item>
                            <NavDropdown.Item href={`${config.baseUrl}launchpad#listed`}>
                              Listed
                            </NavDropdown.Item>
                          </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="3" className="">
                          <Accordion.Header>
                            {" "}
                            <img
                              src="images/dashboard/icon/swap.svg"
                              className=""
                              alt=""
                            />
                            Swap
                          </Accordion.Header>
                          <Accordion.Body className="p-0">
                            <NavDropdown.Item href="#action/3.2">
                              SbSe Order Book (soon)
                            </NavDropdown.Item>
                            <NavDropdown.Item href="#action/3.3">
                              SbSe Instant (soon)
                            </NavDropdown.Item>
                            <NavDropdown.Item href="#action/3.3">
                              MarketPlace (soon)
                            </NavDropdown.Item>
                            <NavDropdown.Item href="#action/3.3">
                              INFI Hybrid eWallet (soon)
                            </NavDropdown.Item>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    </div>
                  </NavDropdown>
                </Nav>
                <Form className="d-sm-flex align-items-center justify-content-end">
                  <h4 className="text-gradient">
                    <b>{console.log("qqqq", isConnected, address, chainId)}</b>
                  </h4>
                  <div className=" mt-md-4 mb-4">
                    <div className="connect-btn d-flex ">
                      {chain && (
                        <>
                          <span
                            style={{
                              display: "inline-block",
                              width: "8px",
                              height: "8px",
                              backgroundColor: "lightgreen",
                              borderRadius: "50%",
                              marginRight: "6px",
                              marginTop: "15px",
                            }}
                          ></span>
                          <span
                            style={{
                              className: "me-xxl-3 ",
                              fontWeight: "bold",
                              whiteSpace: "nowrap",
                              marginRight: "20px",
                              marginTop: "5px",
                            }}
                          >
                            {isConnected ? chain.name.toString() : ""}
                          </span>
                        </>
                      )}
                      <Button
                        variant="primary"
                        className="text-nowrap rounded-5 px-4"
                        style={{ fontSize: "14px" }}
                        onClick={(e) => show(e)}
                      >
                        {isConnected
                          ? address.toString().substring(0, 4) +
                            "...." +
                            address
                              .toString()
                              .substring(address.length - 4, address.length)
                          : "Connect Wallet"}
                      </Button>
                    </div>
                  </div>

                  {/* {isLoggedIn ? (
                                        <>
                                            <Button
                                                variant="dark"
                                                onClick={e => { logout(e) }}
                                                className="ms-sm-3 h-auto rounded-5 px-4 text-nowrap">
                                                Logout
                                            </Button>
                                        </>
                                    ) : (
                                        <>
                                            <Button
                                                variant="dark"
                                                onClick={e => { login(e) }}
                                                className="ms-sm-3 h-auto rounded-5 px-4 text-nowrap">
                                                Login
                                            </Button>

                                            <Button
                                                variant="dark"
                                                onClick={e => { signup(e) }}
                                                className="ms-3 h-auto rounded-5 px-4 text-nowrap">
                                                Sign Up
                                            </Button>
                                        </>
                                    )} */}
                </Form>
              </Navbar.Collapse>
            </Container>
          </Navbar>
        </>
      </section>
    </>
  );
}
